export const SEARCH_DATA_EMPLOYEE_LIST = "SEARCH_DATA_EMPLOYEE_LIST";

export interface employeeSearchData {
	type: typeof SEARCH_DATA_EMPLOYEE_LIST
	payload: any
}


export type searchingDataDispatchTypes = employeeSearchData
